<template>
  <HeaderContent title="Check In"/>
  <ActionContent :cta="false" ctaText="CheckIn" @action="modal = !modal" :filterDate="false" @showFilter="modalFilter = !modalFilter"/>
  <CheckInStatistics title="Check In Statistics" :data="statistics" />
  <CheckinForm :modal="modal" @update:modal="modal = $event" />
  <CheckInConfirm title="Check In Confirmation" :modalConfirm="modalCheckIn" @update:modalConfirm="modalCheckIn = $event">
    <template #text>Are you sure to check in this data ?</template>
  </CheckInConfirm>
  <CheckInFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event" />
  <CheckInDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>

<script>
import { ref } from "vue";
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import CheckinForm from "./CheckInForm.vue";
import CheckInFilter from "./CheckInFilter.vue";
import CheckInConfirm from "@/components/ModalDialog.vue";
import CheckInStatistics from '@/components/StatisticData.vue';
import CheckInDataTable from '@/components/DataTable.vue';
import iconAlready from '../../../public/icons/assessment.svg';
import iconIncoming from '../../../public/icons/to-do.svg';
import iconCheckIn from '../../../public/icons/clipboard-check.svg';


export default {
    name: 'CheckInIndex',
    components: {
        HeaderContent,
        ActionContent,
        CheckinForm,
        CheckInFilter,
        CheckInConfirm,
        CheckInStatistics,
        CheckInDataTable,
    },

    setup(){
        const modal = ref(false)
        const modalCheckIn = ref(false)
        const modalFilter = ref(false)

        const data = ref([
            {
              reservation_no: 'DR-01/11/02/2024', 
              type_room: 'Deluxe', 
              no_room: 'A3',
              guest_name: 'Macdonald',
              arrival: '13/02/2025',
              departure: '18/02/2025',
              total_night: '3',
              status_payment: 'Lunas',
              balance: '0',
            },
            {
              reservation_no: 'DR-02/11/02/2024', 
              type_room: 'Super Deluxe', 
              no_room: 'A3',
              guest_name: 'Macdonald',
              arrival: '13/02/2025',
              departure: '18/02/2025',
              total_night: '3',
              status_payment: 'Lunas',
              balance: '0',
            },
            {
              reservation_no: 'DR-03/11/02/2024', 
              type_room: 'Honeymoon', 
              no_room: 'A3',
              guest_name: 'Macdonald',
              arrival: '13/02/2025',
              departure: '18/02/2025',
              total_night: '3',
              status_payment: 'DP',
              balance: '500.000',
            },
            {
              reservation_no: 'DR-03/11/02/2024', 
              type_room: 'Family', 
              no_room: 'A3',
              guest_name: 'Macdonald',
              arrival: '13/02/2025',
              departure: '18/02/2025',
              total_night: '3',
              status_payment: 'DP',
              balance: '1.000.000',
            },
            {
              reservation_no: 'DR-03/11/02/2024', 
              type_room: 'Studio', 
              no_room: 'A3',
              guest_name: 'Macdonald',
              arrival: '13/02/2025',
              departure: '18/02/2025',
              total_night: '3',
              status_payment: 'Lunas',
              balance: '0',
            },
            
        ])
        const headers = ref([
          {
            key: 'reservation_no', label: 'Reservation No', sortable: true,
          },
          {
            key: 'type_room', label: 'Room Type', sortable: true,
          },
          {
            key: 'guest_name', label: 'Guest Name', sortable: true,
          },
          {
            key: 'arrival', label: 'Arrival', sortable: true,
          },
          {
            key: 'departure', label: 'Departure', sortable: true,
          },
          {
            key: 'total_night', label: 'Total Night', sortable: true,
          },
          {
            key: 'status_payment', label: 'Payment Status', sortable: true,
          },
          {
            key: 'balance', label: 'Balance', sortable: true,
          },
          {
            key: 'action', label: 'Actions'
          },
        ])
        const customActions = ref([
          {
              label: 'Extra Charge',
              variant: 'warning',
              icon: 'fas fa-bolt',
              action: (item) => {
                modal.value = true
              console.log('Info action clicked for:', item);
              // Implement your Info logic here
              }
          },
          {
              label: 'Payment',
              variant: 'primary',
              icon: 'fas fa-money-bill-wave-alt',
              action: (item) => {
                modal.value = true
              console.log('Payment action clicked for:', item);
              // Implement your Payment logic here
              }
          },
          {
              label: 'Check In',
              variant: 'success',
              icon: 'fas fa-calendar-check',
              action: (item) => {
              console.log('Check In action clicked for:', item);
              // Implement your Checkout logic here
              }
          },
        ])

        const statistics = ref([
          {
            label: 'Total',
            key: 'Already Check-In',
            value: 3,
            color: 'success',
            icon: iconAlready,
          },
          {
            label: 'Total',
            key: 'Incoming Check-In',
            value: 8,
            color: 'warning',
            icon: iconIncoming,
          },
          {
            label: 'Total',
            key: 'Check-In',
            value: 11,
            color: 'success',
            icon: iconCheckIn,
          },
        ])

        const actionCta = ref(false)

        return{
            data,
            actionCta,
            headers,
            modal,
            modalFilter,
            modalCheckIn,
            customActions,
            statistics
            
        }
    }

}
</script>

<style>

</style>